import _ from "lodash";
import {useSelector} from "react-redux";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol
} from "../../utils/display-utils";
import Table from "../table/Table";
import RemarkDetail from "../inspection/RemarkDetail";
import React from "react";

export const LimitInputValue = ({itemJudgment, type, unit}) => {
  let text = '-';
  if (_.isEmpty(unit)) {
    unit = '';
  }
  if (type === 'upper') {
    text = itemJudgment.upper_value + unit + itemJudgment.upper_text;
  }
  if (type === 'lower') {
    text = itemJudgment.lower_value + unit + itemJudgment.lower_text;
  }
  return (
    itemJudgment.has_value_limit && <span>{text}</span>
  );
}

export const InspectionItemResult = ({items, itemOrder}) => {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const item = _.find(items, {inspection_item: {item_order: itemOrder}});
  return (
    <>
    <span
      style={{
        color: getInspectionResutlColor(
          Number(item?.result),
          resultSymbolSetting,
        ),
        background: getInspectionResutlBackground(
          Number(item?.result),
          resultSymbolSetting
        ),
      }}>
  {getInspectionResutlSymbol(
    item?.result,
    resultSymbolSetting,
  )}
      </span>
      {item?.inspection_item?.inspection_item_type?.name === "input" &&
      (item.inspection_item_value && (
        <>
          <span className="ml-[8px]">
              {item.inspection_item_value}
          </span>
          <span className="ml-[8px]">
          {item.inspection_item.unit}
          </span>
        </>
      ))}
    </>
  );
};

export const JudgmentResultText = ({result}) => {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  return (
    <>
  <span
    style={{
      color: getInspectionResutlColor(
        Number(result),
        resultSymbolSetting
      ),
      background: getInspectionResutlBackground(
        Number(result),
        resultSymbolSetting
      ),
    }}>        {getInspectionResutlSymbol(result, resultSymbolSetting)}
      </span>
      <span className="ml-1">
        {result === 1 && "承認"}
        {result === 0 && "差し戻し"}
      </span>
    </>
  );
};

export const TreatmentItemResultRow = ({itemResult, itemId, items, treatmentNumber}) => {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const id = parseInt(itemId);
  const item = _.find(items, {id: id});
  if (treatmentNumber === 0 && Number(itemResult?.result) !== 0) {
    return null;
  }
  return (
    <Table.Row>
      <Table.Cell>
        <span>{item?.item_order}</span>
      </Table.Cell>
      <Table.Cell className="px-1 max-w-[360px]">
        <InspectionItemTitle item={item}/>
      </Table.Cell>
      <Table.Cell className="px-1">
        <InspectionItemDescription item={item}/>
      </Table.Cell>
      <Table.Cell className="px-1 min-w-[100px]">
        {item?.inspection_item_type === "input" &&
        (item.inspection_judgment ? (
          <LimitInputValue
            itemJudgment={item.inspection_judgment}
            type="lower"
          />
        ) : (
          "-"
        ))}
        {item?.inspection_item_type === "checkbox" && <span>-</span>}
      </Table.Cell>
      <Table.Cell className="px-1 min-w-[100px]">
        {item?.inspection_item_type === "input" &&
        (item.inspection_judgment ? (
          <LimitInputValue
            itemJudgment={item.inspection_judgment}
            type="upper"
          />
        ) : (
          "-"
        ))}
        {item?.inspection_item_type === "checkbox" && <span>-</span>}
      </Table.Cell>
      <Table.Cell className="px-0.5 min-w-[40px]">
        <span className="whitespace-nowrap">{item?.unit ? `(${item.unit})` : '-'}</span>
      </Table.Cell>
      <Table.Cell className="px-1">
        <RemarkDetail rowData={item}/>
      </Table.Cell>
      <Table.Cell className="max-w-[13%] w-full">
        <p>
          <span
            style={{
              color: getInspectionResutlColor(
                Number(itemResult?.result),
                resultSymbolSetting
              ),
              background: getInspectionResutlBackground(
                Number(itemResult?.result),
                resultSymbolSetting
              ),
            }}>
            {getInspectionResutlSymbol(
              Number(itemResult?.result),
              resultSymbolSetting,
            )}
          </span>
          {item?.inspection_item_type === 'input' && (
            <>
              <span className="ml-[8px]">
                {itemResult?.inspection_item_value}
              </span>
              {itemResult?.inspection_item_value && (
                <span className="ml-[8px]">
                                {item?.unit}
                              </span>
              )}
            </>
          )}
        </p>
      </Table.Cell>
    </Table.Row>
  );
};

export const InspectionItemTitle = ({item}) => {
  return (
    <span
      className="inline-block break-words"
      style={{color: item?.title_color}}
    >
      {item?.title}
    </span>
  );
};

export const InspectionItemDescription = ({item}) => {
  return (
    <span
      className="inline-block break-words"
      style={{color: item?.description_color}}
    >
      {item?.description}
    </span>
  );
};